import { Modal, Text } from '@mantine/core';
import { MessageEmailPreview } from '../MessageEmailPreview/MessageEmailPreview';
import styles from './TemplatePreviewModal.module.sass';

type TemplatePreviewModalProps = {
  opened: boolean;
  onClose: () => void;
  title: string;
  content: string;
};

export const TemplatePreviewModal = ({ opened, onClose, title, content }: TemplatePreviewModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text size="xl" fw={600}>
          {title}
        </Text>
      }
      size="xl"
      centered
      classNames={{
        header: styles.modalHeader,
        title: styles.modalTitle,
        close: styles.closeButton,
        body: styles.modalBody,
      }}
    >
      <div className={styles.previewContent}>
        <MessageEmailPreview content={content} className={styles.previewIframe} />
      </div>
    </Modal>
  );
};
